module.exports = __webpack_public_path__ + "media/images/favicon32x32-b5d01b5d4beb87291cc07010c004d21b.png";